import { render } from "./DowngradeSection.vue?vue&type=template&id=bbe321d8"
import script from "./DowngradeSection.vue?vue&type=script&lang=js"
export * from "./DowngradeSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__